module.exports = __webpack_public_path__ + "static/media/svgskilt_quizstopp-trackpoi_quiz.1cb2b5f3.svg";